<template>
  <div class="col-sm-10 col-md-7 col-xs-12 tablet-width start-xs no-products">
    <base-input
      class="w-100"
      :class="{active: open}"
      type="text"
      name="no-product-select"
      :placeholder="$t('При відсутності товару у магазині…')"
      :autosize="false"
      :maxlength="0"
      :readonly="true"
      v-model="selected"
      @click="handleSelectFocus(!open)"
      @blur="handleSelectFocus(false)"
    />
    <ul class="options-list" :class="{active: open}">
      <li
        v-for="(option, index) of checkboxTitle"
        :key="index"
        @click="changed(option.label)"
      >
        {{ option.label }}
      </li>
    </ul>
  </div>
</template>
<script>
const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');

export default {
  name: 'NoProduct',
  components: {
    BaseInput
  },
  props: {
    partner: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      checkboxTitle: [
        {
          value: 'call',
          label: 'Передзвонити для уточнення заміни'
        },
        {
          value: 'replace',
          label: 'Замінити на свій розсуд'
        },
        {
          value: 'no_replace',
          label: 'Не замінювати'
        }
      ],
      selected: 'call',
      open: false,
      timeout: null
    }
  },
  mounted () {
    let value = localStorage.getItem(`shop/checkoutFieldValues/noProduct_${this.partner}`);
    if (value) {
      this.changed(value)
      this.selected = value
    }
  },
  beforeDestroy () {
    if (this.timeout) clearTimeout(this.timeout);
  },
  methods: {
    handleSelectFocus (state) {
      this.timeout = setTimeout(() => {
        this.open = state;
      }, 200);
    },
    changed (value) {
      this.selected = value;
      this.$bus.$emit('checkout-no-product-changed', { partner: this.partner, value });
      localStorage.setItem(`shop/checkoutFieldValues/noProduct_${this.partner}`, value);
      this.handleSelectFocus(false);
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-products {
    height: 44px;
    margin: 0 auto 24px;
    position: relative;

    @media only screen and (max-width: 425px) {
      margin: 0 auto 16px;
    }

    .base-input {
      z-index: 2;
      min-height: fit-content;
      margin: 0 -8px;
      width: -webkit-fill-available;

      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 1.25rem;
        right: 10px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 8px 6px 0 6px;
        border-color: #bdbdbd transparent transparent transparent;
        pointer-events: none;
        transition: all 0.3s ease;
      }

      &.active {
        &::after {
          transform: rotate(180deg);
        }
      }
    }

    .options-list {
      text-align: left;
      display: flex;
      flex-direction: column;
      border: 1px solid #bdbdbd;
      border-radius: 5px;
      margin: 0;
      padding: 0;
      list-style: none;
      position: absolute;
      background: white;
      z-index: 1;
      top: 40px;
      left: 0;
      border-top: none;
      box-shadow: 0px 2px 5px 0px #00000033;
      opacity: 0;
      visibility: hidden;
      transform: translateY(-10%);
      transition: all 0.3s ease;
      width: -webkit-fill-available;

      &.active {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }

      >li {
        padding: 4px 18px;
        border-radius: 5px;
        &:first-of-type {
          padding-top: 14px;
        }
        &:last-of-type {
          padding-bottom: 14px;
        }
        &:not(.no_action) {
          cursor: pointer;
          &:hover {
            background-color: #F2F2F2;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  .no-products {
    .base-input {
      input[name="no-product-select"] {
        font-size: 15px;
        cursor: pointer;
      }
    }
  }
</style>
